"use client";

import { StoreAndLanguageSelector } from "@/components/CountryRedirectionModal/StoreAndLanguageSelector";
import {
  ModalBody,
  ModalFooter,
  ModalHeading,
  ModalParagraph,
} from "@/components/CountryRedirectionModal/styles";
import { Modal } from "@/components/Modal";
import { useStore } from "@/hooks/useStore";
import { CookieKeys, OneYearExpirationTimeInDays } from "@/utils/constants";
import { setCookie } from "@/utils/cookie";
import { Button } from "@getgrover/ui";
import { useLocale, useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { useState, useTransition } from "react";

export const CountryRedirectionModal = ({ forceOpen = false }) => {
  const t = useTranslations("country_redirection");
  const locale = useLocale();
  const router = useRouter();
  const { store } = useStore();

  const [isTranslating, startTransition] = useTransition();

  const [isOpen, setIsOpen] = useState(true);

  const [desiredStore, setDesiredStore] = useState(store);
  const [desiredLocale, setDesiredLocale] = useState(locale);

  const handleClose = () => {
    setCookie(
      CookieKeys.UserCountryRedirectionModalSeen,
      "true",
      OneYearExpirationTimeInDays,
    );
    setIsOpen(false);
  };

  const handleConfirm = () => {
    startTransition(() => {
      router.replace(`/${desiredLocale}/${desiredStore}`);
      handleClose();
    });
  };

  return (
    <Modal
      isOpen={isOpen || forceOpen}
      isOutsideClickDisabled
      onClose={handleClose}
    >
      <ModalBody>
        <ModalHeading>{t("heading")}</ModalHeading>
        <ModalParagraph>{t("description")}</ModalParagraph>
        <StoreAndLanguageSelector
          storeCode={desiredStore}
          locale={desiredLocale}
          onStoreChange={setDesiredStore}
          onLanguageChange={setDesiredLocale}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          fullWidth
          variant="Primary"
          onClick={handleConfirm}
          disabled={isTranslating}
        >
          {t("cta")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
